export default __webpack_public_path__ + "static/media/video_6_peronospora.19adef39.mp4";